import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { confirmButtons } from '../Modals/ModalButtons';
import TreeSelection from './TreeSelection';
import './TreeSelectionModal.css';

const TreeSelectionModal = ({ isOpen, selections, onConfirm, onCancel, allowAssets, allowNodes, allowSelectionChange }) => {
  const T = useTranslation();
  const [newSelections, setNewSelections] = useState(selections);
  useEffect(() => {
    setNewSelections(selections);
  }, [selections]);

  const _onConfirm = useCallback(() => {
    onConfirm(newSelections);
  }, [newSelections, onConfirm]);

  const onSelectionsChanged = useCallback((newSelections) => {
    setNewSelections(newSelections);
  }, []);

  return (
    <Modal
      variant={ModalVariant.large}
      tabIndex={0}
      className={'modal'}
      title={T.common.input.nodes.selectmultiple}
      isOpen={isOpen}
      onClose={onCancel}
      actions={confirmButtons({ T, onConfirm: _onConfirm, onCancel })}
    >
      <TreeSelection
        selections={newSelections}
        onSelectionsChanged={onSelectionsChanged}
        allowAssets={allowAssets}
        allowNodes={allowNodes}
        allowSelectionChange={allowSelectionChange}
      />
    </Modal>
  );
};

export default React.memo(TreeSelectionModal);
